import { FireScreenEventOnMountStateless } from '@atlassian/help-center-common-util/analytics/fire-screen-event/fire-screen-event';
import { withScreenName } from '@atlassian/help-center-common-util/analytics/screen-name-context';

const FireScreenEventOnMount = withScreenName(FireScreenEventOnMountStateless);

// Manually set the display name for sensible snapshots
FireScreenEventOnMount.displayName = 'FireScreenEventOnMount';

export { FireScreenEventOnMount };
